import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

import { Filter } from '../../../shared/filter';
import { BaseApiService } from '../base.service';
import { BaseLoopBackApiServiceInterface } from './base.service.interface';
import { BaseLoopBackStorageService } from '../../storage/loopback/base.service';
import { BaseErrorService } from '../../error/base.service';
import { ITEMS_PER_PAGE } from '../../../shared/constants';

@Injectable()
export class BaseLoopBackApiService extends BaseApiService implements BaseLoopBackApiServiceInterface {

  public count(where: any): Observable<any> {
    let options = {
      pathUrl: 'count',
      params: {
        where: where
      }

    };
    return this.get(options);
  }

  public find(filter?: Filter): Observable<any> {
    if (filter == undefined) {
      filter = new Filter({});
    }
    if (filter.limit == undefined) {
      filter.limit = ITEMS_PER_PAGE;
    }
    if (filter.order == undefined) {
      filter.order = 'ticket.startDate DESC';
    }
    let options = {
      params: {
        filter: filter.toString()
      }
    };
    return this.get(options);
  }

  public findById(id: string, filter?: Filter): Observable<any> {
    let options: any = {
      pathUrl: ':id',
      urlParams: {
        id: id
      },
      params: {
        filter: filter ? filter.toString() : {}
      }
    };
    return this.get(options);
  }

  public create(body: any): Observable<any> {
    let options: any = {
      body: body
    };
    return this.post(options);
  }

  public patchAttributes(id: string, body: any): Observable<any> {
    let options: any = {
      body: body,
      pathUrl: ':id',
      urlParams: {
        id: id
      },
    };
    return this.patch(options);
  }

  public resetById(id: string): Observable<any> {
    let options: any = {
      pathUrl: ':id/reset',
      urlParams: {
        id: id
      },
    };
    return this.put(options);
  }

  public deleteById(id: string): Observable<any> {
    let options: any = {
      pathUrl: ':id',
      urlParams: {
        id: id
      },
    };
    return this.delete(options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api/loopback/base.service.ts